export const DELETE_BTN = {
  width: "auto",
  color: "red",
  borderColor: "red !important",
  "&:hover": { background: "rgba(255, 0, 0, 0.1)" },
  fontFamily: `var(--font-family)`,
  borderRadius: "calc(var(--border-radius) - 4px)",
  zIndex: "5 !important",
};

export const CANCEL_BTN = {
  width: "auto",
  color: "white",
  borderColor: "white !important",
  "&:hover": { background: "var(--white-color-1)" },
  fontFamily: `var(--font-family)`,
  borderRadius: "calc(var(--border-radius) - 4px)",
};

export const NOTIFICATION_ICON = {
  color: "var(--font-color)",
  fontSize: "2rem",
  marginRight: "var(--small-margin)",
};

export const DELETE_ICON = {
  color: "red",
  transition: "transform 1s ease",
  position: "absolute",
  top: "8px",
  right: "10px",
};

export const MAIN_INFO_CARD = {
  background: "var(--primary-color)",
  border: "var(--border-bold)",
  borderRadius: "var(--border-radius)",
  color: "var(--font-color)",
  fontFamily: `var(--font-family)`,
  margin: "0",
};

export const BUTTON_STYLES = {
  background: "var(--button-light-bg) !important",
  borderRadius: "var(--button-radius)",
  border: "1px solid var(--button-light-border)",
  boxShadow: "var(--button-light-shadow)",
  fontWeight: "700",
  fontFamily: `"Montserrat", Arial, sans-serif`,
  fontSize: "var(--button-text-size-small)",
  color: "var(--button-light-color)",
  textTransform: "none",
  transition: "transform var(--button-transition), box-shadow var(--button-transition), background var(--button-transition)",
  "&:hover": {
    background: "var(--button-light-bg) !important",
    boxShadow: "var(--button-light-hover-shadow)",
    transform: "translateY(-2px)",
  },
  "&:focus-visible": {
    outline: "3px solid var(--secondary-color-1)",
    outlineOffset: "3px",
  },
  "&:active": {
    transform: "translateY(0)",
  },
};


export const BUTTON_STYLES_ON_BLUE = {
  background: "var(--button-blue-bg) !important",
  borderRadius: "var(--button-radius)",
  border: "1px solid var(--button-blue-border)",
  boxShadow: "var(--button-blue-shadow)",
  fontWeight: "700",
  fontFamily: `"Montserrat", Arial, sans-serif`,
  fontSize: "var(--button-text-size-small)",
  color: "var(--button-blue-color) !important",
  textTransform: "none",
  transition: "transform var(--button-transition), box-shadow var(--button-transition), background var(--button-transition)",
  "&:hover": {
    background: "var(--button-blue-bg) !important",
    color: "var(--button-blue-color) !important",
    boxShadow: "var(--button-blue-hover-shadow)",
    transform: "translateY(-2px)",
  },
  "&:focus-visible": {
    outline: "3px solid var(--secondary-color-1)",
    outlineOffset: "4px",
  },
  "&:active": {
    transform: "translateY(0)",
  },
};

export const CALL_TO_ACTION_BUTTON_STYLES = {
  border: "1px solid var(--button-light-border)",
  borderRadius: "var(--button-radius)",
  boxShadow: "var(--button-light-shadow)",
  background: "var(--button-light-bg) !important",
  color: "var(--button-light-color)",
  position: "relative",
  fontSize: "var(--button-text-size-big)",
  fontFamily: `"Montserrat", Arial, sans-serif`,
  fontWeight: "700",
  textTransform: "none",
  padding: "0",
  overflow: "visible",
  transition: "transform var(--button-transition), box-shadow var(--button-transition), background var(--button-transition)",
  "&:hover": {
    background: "var(--button-light-bg) !important",
    boxShadow: "var(--button-light-hover-shadow)",
    transform: "translateY(-2px)",
  },
  "&:focus-visible": {
    outline: "3px solid var(--secondary-color-1)",
    outlineOffset: "3px",
  },
  "&:active": {
    transform: "translateY(0)",
  },
};

export const SETTINGS_BUTTON_STYLES = {
  color: "var(--font-color)",
  position: "absolute",
  left: "5px",
};

export const TEXT_FIELD_STYLES = {
  "& input": {
    color: "var(--font-color)",
    fontFamily: `var(--font-family)`,
  },
  "& label": { color: "var(--font-color)" },
  "& .MuiOutlinedInput-root": {
    "& fieldset": { borderColor: "rgba(225, 225, 225, 0.8) !important" },
    "&:hover fieldset": { borderColor: "white !important" },
    borderRadius: "calc(var(--border-radius) - 4px)",
  },
};

export const CONFIRMATION_MODAL = {
  background: "var(--primary-color)",
  borderRadius: "var(--border-radius)",
  backdropFilter: "blur(30px)",
  border: "var(--border-light)",
};

export const CLOSE_BTN = {
  position: "absolute",
  top: "var(--inset-position)",
  right: "var(--inset-position)",
  color: "var(--font-color)",
};

export const ICON_SIZE_SMALL = {
  fontSize: "26px",
};

export const ICON_SIZE_BIG = {
  fontSize: "36px",
};

export const SMALL_SCREEN_825 = "(max-width: 825px)";

export const SMALL_SCREEN_1000 = "(max-width: 1000px)";

export const INITIAL = {
  opacity: 0,
};

export const ANIMATE = {
  opacity: 1,
};

export const EXIT = {
  opacity: 0,
};

export const TRANSITION = {
  duration: 0.5,
};

export const ORGANIZER_CARD_MOTION = {
  hidden: { opacity: 0, x: -100 },
  hiddenAlt: { opacity: 0, x: 100 },
  visible: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: 100 },
  exitAlt: { opacity: 0, x: -100 },
};

export const LIST_MARKER_MOTION = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0 },
};

export const ORGANIZER_PHOTO_MOTION = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0 },
};

export const MOTION_MARGIN = "-50px 0px -50px 0px";

export const MOTION_MARGIN_SMALL = "50px 0px 50px 0px";

export const NEWS_LIST_ITEM_SKELETON = {
  height: "100%",
  minHeight: "350px",
  width: "calc(100% - var(--small-margin) * 2)",
  bgcolor: "var(--white-color-1)",
  margin: "var(--small-margin)",
  borderRadius: "var(--border-radius)",
};

export const PROJECTS_LIST_ITEM_SKELETON = {
  height: "200px",
  width: "100%",
  bgcolor: "var(--white-color-1)",
  borderRadius: "var(--border-radius)",
};

export const CARDS_ANIMATION = {
  hidden: { opacity: 0, scale: 0.5 },
  visible: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.5 },
};

export const STANDARD_ICON_STYLES = {
  color: "var(--font-color)",
  fontSize: "28px",
};
